document.addEventListener('DOMContentLoaded', function () {
  var close = document.querySelector('.modal-header .close');

  if (close) {
    close.addEventListener('click', function (e) {
      // Get modal wrapper div and hide
      e.target.parentNode.parentNode.parentNode.parentNode.style.display = 'none';
    });
  }
});
